export default __webpack_public_path__ + "static/media/thelair.e6d55eb1.jpg";